var mp = mp || {};

// Data Tables
//-----------------------------------------------------------------
mp.dataTabels = function() {

    var $containter = $('#dataTables');
    if (!$containter.length) {
        return;
    }

    $.extend( $.fn.dataTable.defaults, {
    	responsive: false,
    	lengthChange: false,
        ordering: false,
        paging: true,
        pageLength: 25,
        pagingType: "listbox"
    });
    
    if ($containter.data("row-reorder")) {
        $.extend( $.fn.dataTable.defaults, {
            ordering: true,
            paging: false,
            scrollY: 600,
            scrollCollapse: true,
            columnDefs: [
                { targets: 0, visible: false },
                { orderable: false, targets: '_all' }
            ],
            rowReorder: {
                snapX: true,
                selector: 'td:last-child',
            }
        });
    }

    var $dateTable = $containter.DataTable();

    $dateTable.on( 'row-reorder', function ( e, details, edit ) {
        $.ajax({
          method: "POST",
          url: "update.php?update_type=sort",
          data: edit.values,
        });
    });
};


// TinyMCE
//-----------------------------------------------------------------
mp.tinyMCE = function() {

    var $containter = $('.tinyMCE');
    if (!$containter.length) {
        return;
    }

    tinymce.init({
        selector: '.tinyMCE',
        themes: 'modern',
        height: 500,
        menubar: false,
        relative_urls: false,
        media_live_embeds: true,
        media_alt_source: false,
        media_poster: false,
        paste_as_text: true,
        plugins: [
            'autolink lists link charmap print',
            'searchreplace visualblocks code, media, image',
            'insertdatetime table paste code'
        ],
        toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image media | removeformat | code',
        file_picker_types: 'image',
        file_picker_callback: function(callback, value, meta) {
            $.fancybox.open({
                src  : 'media.php?type=select&media=editor',
                type : 'ajax',
                opts : {
                    filter : '#media-wrapper',
                }
            });
        }
    });
};


// Set Datepicker
//-----------------------------------------------------------------
mp.datePicker = function() {
    var $element = $('.js_datePicker');
    if (!$element.length) {
        return;
    }

    $element.datetimepicker({
        widgetPositioning: {
            horizontal: 'left'
        },
        icons: {
            time: "fa fa-clock-o",
            date: "fa fa-calendar",
            up: "fa fa-arrow-up",
            down: "fa fa-arrow-down",
            previous: 'fa fa-arrow-left',
            next: 'fa fa-arrow-right'
        },
        format: 'DD.MM.YYYY.'
    });
};


// Set Datepicker Range
//-----------------------------------------------------------------
mp.datePickerRange = function() {
    var $from = $('.js_datePickerFrom');
    var $to = $('.js_datePickerTo');
    if (!$from.length || !$to.length) {
        return;
    }

    $from.datetimepicker({
        widgetPositioning: {
            horizontal: 'auto'
        },
        icons: {
            time: "fa fa-clock-o",
            date: "fa fa-calendar",
            up: "fa fa-arrow-up",
            down: "fa fa-arrow-down",
            previous: 'fa fa-arrow-left',
            next: 'fa fa-arrow-right'
        },
        format: 'DD.MM.YYYY.'
    });

    $to.datetimepicker({
        widgetPositioning: {
            horizontal: 'right'
        },
        focusOnShow: false,
        icons: {
            time: "fa fa-clock-o",
            date: "fa fa-calendar",
            up: "fa fa-arrow-up",
            down: "fa fa-arrow-down",
            previous: 'fa fa-arrow-left',
            next: 'fa fa-arrow-right'
        },
        format: 'DD.MM.YYYY.',
        useCurrent: false
    });

    $from.on("dp.change", function (e) {
       $to.data("DateTimePicker").minDate(e.date);
    });
    $to.on("dp.change", function (e) {
       $from.data("DateTimePicker").maxDate(e.date);
    });
};


// Set Timepicker
//-----------------------------------------------------------------
mp.timePicker = function() {
    var $element = $('.js_timePicker');
    if (!$element.length) {
        return;
    }

    $element.datetimepicker({
        format: 'HH:mm',
        stepping: 15,
        icons: {
            up: "icmn-plus",
            down: "icmn-minus"
        }
    });
};



// Action Alert
//-----------------------------------------------------------------
mp.actionAlert = function() {
    $(document).on('click', '[data-alert]', function(e){
        var pop = confirm("Are you sure?");
        if (pop != true) {
            e.preventDefault();
            return false;
        }
    });
};




// Background image holder
//-----------------------------------------------------------------
mp.backgroundHolder = function() {
    var $element = $(".background-holder");

    if (!$element.length) {
        return;
    }

    $element.each(function(){
        var $img = $(this).find('img');

        if ($img.length) {
            var $imageSrc = $img.attr('src');
            $img.remove();
            $(this).css('background-image', 'url("'+$imageSrc+'")');
        }
    });
};


// Tooltip
//-----------------------------------------------------------------
mp.Tooltip = function() {
    var $element = $('[data-toggle="tooltip"]');

    if (!$element.length) {
        return;
    }

    $element.tooltip({
        placement: "top"
    });
};



$.notifyDefaults({
    allow_dismiss: false,
    placement: {
        from: "bottom",
        align: "right",
    },
    template: '<div data-notify="container" class="col-xs-11 col-sm-2 alert alert-{0}" role="alert">' +
                '<span data-notify="message">{2}</span>' +
            '</div>',
});


// Select2
//-----------------------------------------------------------------
mp.select2 = function() {
    var $element = $('.select-search');

    if (!$element.length) {
        return;
    }

    $element.select2();
};


// Select Multiple
//-----------------------------------------------------------------
mp.selectMultiple = function() {
    var $element = $('.select-multiple');

    if (!$element.length) {
        return;
    }

    $element.select2();
};


// Remove Row
//-----------------------------------------------------------------
mp.removeRow = function() {
    var $element = $('[data-remove="row"]');

    if (!$element.length) {
        return;
    }

    $element.on('click', function(){
        $(this).parents("tr").remove();
    })
};




$(document).ready(function (){
    mp.dataTabels();
    mp.tinyMCE();
    mp.datePicker();
    mp.datePickerRange();
    mp.timePicker();
    mp.actionAlert();
    mp.backgroundHolder();
    mp.Tooltip();
    mp.select2();
    mp.selectMultiple();
    mp.removeRow();
});